/**
 * Animation properties, (like threshold, hideOnStart etc.)
 * Properties are by animation name, so we assume the properties on the default animation are correct
 * and collect from other view modes only those who doesn't have defaults
 */
function getAllAnimationProperties({ defaults = {}, mobile = {}, }) {
    const defaultProperties = Object.values(defaults).reduce((acc, animationDef) => {
        acc[animationDef.name] = animationDef.properties;
        return acc;
    }, {});
    const restOfDefs = [...Object.values(mobile)];
    return restOfDefs.reduce((acc, animationDef) => {
        if (!acc[animationDef.name]) {
            acc[animationDef.name] = animationDef.properties;
        }
        return acc;
    }, defaultProperties);
}
/**
 * Normalize view mode to lower case, and default to internal 'defaults' for 'desktop' viewMode
 * We need this to deal with Santa getViewMode()
 */
function getAnimationMode(viewMode = '') {
    const normalizedViewMode = viewMode.toLowerCase();
    return normalizedViewMode !== 'desktop'
        ? normalizedViewMode
        : 'defaults';
}
export { getAllAnimationProperties, getAnimationMode };
//# sourceMappingURL=definitionsUtils.js.map